@if (isIntroShown) {
  <app-slide-separator
    [type]="data?.type"
    [specialSlide]="data?.quiz ? 'quiz' : undefined"
    [introText]="data?.pre_text"
    [title]="getTitle()"
    (buttonClicked)="launch()"
    [buttonText]="getButtonText()"
    [skipLink]="nextLink"
    [backLink]="backLink">
  </app-slide-separator>
}

@if (data && !isIntroShown) {
  <div class="interactive-content">
    @if (data.launch_url) {
      <iframe [src]="data.launch_url | trustUrl" allow="clipboard-write"></iframe>
    }
  </div>
}
